<template>
	<div>
		<button
			type="button"
			:class="`btn ${'btn-' + color}`"
			v-on:click="onClick($event)"
			:disabled="disabled"
			v-if="!loading">
			{{ label }}
		</button>

		<button type="button" :class="`btn ${'btn-' + color}`" disabled v-if="loading">
			<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
			En cours..
		</button>
	</div>
</template>

<script>
	export default {
		name: 'GLoadingButton',

		props: {
			loading: {
				type: Boolean,
				default: false,
			},
			label: {
				type: String,
				default: '',
			},
			color: {
				type: String,
				default: 'primary',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},

		methods: {
			onClick($event) {
				this.$emit('click', $event);
			},
		},
	};
</script>
